import { Navigate, createFileRoute } from '@tanstack/react-router';

import { routes } from 'shared/routes';

import { VerifyEmail, verifyEmailSearchSchema } from 'features/auth/VerifyEmail';

export const Route = createFileRoute('/auth/_auth/verify-email/')({
  component: VerifyEmailRoute,
  validateSearch: verifyEmailSearchSchema,
  errorComponent: () => <Navigate to={routes.login()} />
});

function VerifyEmailRoute() {
  const { email, redirect: redirectTo } = Route.useSearch();

  return <VerifyEmail email={email} redirectTo={redirectTo} />;
}
